import type { FC, ReactElement } from "react";

import { cn } from "@/lib/utils";

interface DetailsTitleProps {
  title: string;
  children?: ReactElement;
  classes?: string;
}

const DetailsTitle: FC<DetailsTitleProps> = ({ title, children, classes }) => {
  return (
    <h3
      className={cn(
        "text-lg font-extrabold",
        children && "inline-flex items-center gap-2",
        classes
      )}
    >
      {title}
      {children}
    </h3>
  );
};

export default DetailsTitle;
